import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./checkRoutingNumberHelper.html')
})

export class CheckRoutingNumberHelperDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<CheckRoutingNumberHelperDialog>) public dialogRef: MatDialogRef<CheckRoutingNumberHelperDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
